module.exports = __webpack_public_path__ + "static/img/quancheng_04.5290141.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/quancheng_04.png
// module id = Rify
// module chunks = 1